webpackJsonp([217719191756454],{

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DetroitImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DetroitLocation = function (_React$Component) {
	  _inherits(DetroitLocation, _React$Component);
	
	  function DetroitLocation() {
	    _classCallCheck(this, DetroitLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DetroitLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Detroit, MI' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Promoting Ridership',
	        title: 'Motorless City',
	        story: 'At the kickoff meeting of community partners and Mogo Bikeshare, the National Association of City Transportation Officials (NACTO) brought experts from Philadelphia and Brooklyn to Detroit to show how community-based organizations help shape and steer their bike share program equity goals. We attended to learn how we could replicate this roadshow format for other cities through the Better Bike Share Partnership. A highlight was a bike tour with Wheelhouse Detroit owner Kelli Kavanaugh showcasing gems like the Dequindre Cut, the Riverwalk, and the growing art and urban agriculture installations of Detroit.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'DetroitMi',
	        alt: 'Mogo Bikeshare',
	        sizes: this.props.data.detroitImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Huntsville, AL',
	        prevLocationPath: 'huntsville',
	        prevLocationImgPath: this.props.data.detroitPrevImage,
	        nextLocationName: 'Charlotte, NC',
	        nextLocationPath: 'charlotte',
	        nextLocationImgPath: this.props.data.detroitNextImage
	      })
	    );
	  };
	
	  return DetroitLocation;
	}(_react2.default.Component);
	
	exports.default = DetroitLocation;
	
	// GraphQL query
	
	var DetroitImageQuery = exports.DetroitImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-detroit-js-48ce0a58853ed7207275.js